module.exports = __webpack_public_path__ + "img/img14.950c38cc.jpg";